import { create } from 'zustand'

export type SearchFilters = {
  search: string
  collection: string
  category: string
  contentTier: string
  year: string
  contentType: string
  sort: string
}

type SearchContextProps = {
  filters: SearchFilters
  hasActiveFilters: boolean
}

export type SearchContextActions = {
  setFilters: (filters: SearchFilters) => void
  setFilter: (filter: keyof SearchFilters, value: string) => void
  clearFilters: () => void
}

type SearchContext = SearchContextProps & SearchContextActions

const INITIAL_STATE = (): SearchContextProps => ({
  filters: {
    search: '',
    collection: '',
    category: '',
    contentTier: '',
    year: '',
    contentType: '',
    sort: '-publishedAt',
  },
  hasActiveFilters: false,
})

const hasActiveFilters = (filters: SearchFilters) => {
  const { search: _, sort: __, ...filtersWithoutSearchAndSort } = filters
  const { search: ___, sort: ____, ...initialFiltersWithoutSearchAndSort } = INITIAL_STATE().filters
  return JSON.stringify(filtersWithoutSearchAndSort) !== JSON.stringify(initialFiltersWithoutSearchAndSort)
}

export const useSearchContext = create<SearchContext>((set) => ({
  ...INITIAL_STATE(),
  setFilters: (filters) =>
    set({ filters, hasActiveFilters: hasActiveFilters(filters) }),
  setFilter: (filter, value) =>
    set((state) => ({
      filters: { ...state.filters, [filter]: value },
      hasActiveFilters: hasActiveFilters({ ...state.filters, [filter]: value }),
    })),
  clearFilters: () =>
    set({ filters: INITIAL_STATE().filters, hasActiveFilters: false }),
}))
